import { createTheme } from "@mui/material/styles";
import ThemeColors from "./theme/colors";
import { tokens } from "./tokens";

const Palette = () => {

  const colors = ThemeColors();

  return createTheme({
    palette: {
      mode: "light",
      common: {
        black: "#000",
        white: "#fff",
      },
      ...colors,
      background: {
        default: tokens.bg,
        paper: tokens.card,
      },
      text: {
        primary: tokens.ink,
        secondary: tokens.muted,
        disabled: "rgba(0,0,0,0.38)"
      },
    },
  });
};

export default Palette;
